<template>
    <div class="custom-day">
        <div class="scroll-box">
            <div class="text-item">每</div>
            <div class="scroll-day">
                <ScrollModule :items="items" :selected="cycle" @submitEvent="submit($event)"/>
            </div>
            <div class="text-item">天</div>
        </div>
        <div class="skip-state">
            <div class="text-skip">智能跳过法定节假日</div>
            <div class="my-cursor"
                 :class="{
                'icon-switch-false': !skipHolidaysState,
                'icon-switch-true': skipHolidaysState,
            }" @click.stop="saveSkipState">
            </div>
        </div>

    </div>
</template>

<script>
import ScrollModule from "@/pages/List/MatterInfo/ScrollModule";
export default {
    name: "RepeatDay",
    components: {
        ScrollModule
    },
    data(){
        return {
            cycle: "01",
            items: [],
        }
    },
    props:{
        repeatCycle: {
            type: Number,
            default: 1,
        },
        skipHolidaysState: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        submit: function(e){
            this.cycle = e;
            this.$emit("submitEvent", {repeatType: "custom_day", repeatCycle: e, repeatInfo: ""});
        },
        saveSkipState: function(){
            this.$emit("submitSkipState", !this.skipHolidaysState);
        },
    },
    created(){

    },
    mounted(){
        this.cycle = this.$Utils.addZero(this.repeatCycle);
        for(let i=1; i<100; i++){
            this.items.push(
                this.$Utils.addZero(i)
            )
        }
    },
}
</script>

<style scoped>
div.custom-day{
    width: 100%;
    background: rgba(254,228,148,0.2);
    border-radius: 0.15rem;
    border: 0.02rem solid #FEE494;
    padding: 0.3rem 0.2rem;
    box-sizing: border-box;

    margin-top: 0.2rem;

}
div.scroll-box{
    width: 100%;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.36rem;
}
div.text-item{
    font-weight: bold;
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.scroll-day{
    width: 0.3rem;
    height: 1.2rem;
    text-align: center;
}
div.skip-state{
    width: 100%;
    height: 0.36rem;
    background: rgba(252, 132, 112, 0.3);
    border-radius: 0.06rem;
    margin-top: 0.2rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.12rem;
}
div.text-skip{
    font-size: 0.15rem;
    color: #000000;
    text-align: center;
}
div.icon-switch-true, div.icon-switch-false{
    width: 0.5rem;
    height: 0.24rem;
}
div.icon-switch-true{
    background: url("../../../assets/images/List/icon-switch-true.png");
    background-size: cover;
}
div.icon-switch-false{
    background: url("../../../assets/images/List/icon-switch-false.png");
    background-size: cover;
}
</style>